import script from "./WClinicChoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./WClinicChoice.vue?vue&type=script&setup=true&lang=ts"

import "./WClinicChoice.vue?vue&type=style&index=0&id=251d785a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251d785a"]])

export default __exports__